import {IComponentOptions} from 'angular';
import TSZahlungsauftragDTO from '../../../models/TSZahlungsauftragDTO';

require('./dv-auszahlung.scss');

export class AuszahlungComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        zahlungsauftrag: '<'

    };
    template = require('./dv-auszahlung.html');
    controller = DvAuszahlungController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvAuszahlungController {
    static $inject = [];

    zahlungsauftrag: TSZahlungsauftragDTO;

    /* @ngInject */
    constructor() {
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-auszahlung/dv-auszahlung.ts